export default store => {
    store.dispatch("api/init")
        .then(() => store.dispatch("cron/init"))
        .then(() => store.dispatch("erp/init"))
        .then(() => store.dispatch("erpcron/init"));
}